module.exports = __webpack_public_path__ + "static/sys_ph07-32d21567575716134302905d899be519.jpg";